export const DAYS_ALLOWED_REFUND_AFTER_SUBMISSION = 3
export const REFUND_BUTTON_TOOLTIP_TEXT = `Refunds may be issued within ${DAYS_ALLOWED_REFUND_AFTER_SUBMISSION * 24} hours after submission.`
export const PaymentMethod = {
  REGGORA_DIRECT: 'reggora_direct',
  LENDER_DIRECT: 'lender_direct',
}
